import TableFilterSelect from '@aibees/elephant/components/table-filter-select/table-filter-select';
import { useAddLabelsGroupingMetadata } from '@aibees/elephant/hooks/labels/use-add-labels-grouping-metadata';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { Stack } from '@mui/material';
import { isEqual } from 'lodash-es';
import { memo } from 'react';
import { CONFIG } from './config';
import type { ListTypeSelectProps as Props } from './types';

export const ListTypeSelect = memo(
  ({ filters, setFilter }: Props) => {
    const optionsWithMetadata = useAddLabelsGroupingMetadata(CONFIG);

    return (
      <Stack flex={0.5}>
        <TableFilterSelect<LabelGrouping>
          filters={filters}
          setFilter={setFilter}
          name="grouping"
          defaultValue={filters.grouping || LabelGrouping.ALL}
          options={optionsWithMetadata}
        />
      </Stack>
    );
  },
  (prevProps, nextProps) => {
    return (
      isEqual(prevProps.filters, nextProps.filters) &&
      prevProps.setFilter === nextProps.setFilter
    );
  }
);

ListTypeSelect.displayName = 'ListTypeSelect';
